module.exports = __webpack_public_path__ + "static/top-remit-opportunity-6421e63c0a5fa801ef43f6059714be1a.jpg";